import React, { Component } from 'react';
import { Link } from 'react-router-dom';


class TemplateSidebar extends Component {
  render() {
    return (
      <div class="sidebar p-3">
        <div class="sidebar-menu d-flex">
          <div class="sidebar-tracer"></div>
          <div id="sidebar-options" class="d-flex flex-column">
            <div class="sidebar-category mt-1">
              <button class="btn btn-link btn-sm pl-3">
                <a class="format-clear float-left" href="#">
                  Welcome
                </a>
              </button>
            </div>
            <div class="sidebar-category mt-1">
              <button id="background-category" class="btn format-clear btn-link btn-sm text-left pl-3" data-toggle="collapse" data-target="#background" aria-expanded="false" aria-controls="background">
                Background
              </button>
              <div id="background" class="collapse hide" aria-labelledby="background-category" data-parent="#sidebar-options">
                <ul class="list-unstyled">
                  <li>
                    <a href="#">
                      Coming Soon
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="sidebar-category mt-1">
              <button id="behind-category" class="btn format-clear btn-link btn-sm text-left pl-3" data-toggle="collapse" data-target="#behind" aria-expanded="false" aria-controls="background">
                Behind Our Model
              </button>

              <div id="behind" class="collapse hide" aria-labelledby="behind-category" data-parent="#sidebar-options">
                <ul class="list-unstyled">
                  <li>
                    <a href="#">
                      Coming Soon
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="sidebar-category mt-1">
              <button id="run-category" class="btn btn-link format-clear btn-sm pl-3">
                <a class="format-clear float-left" href="#">
                  Run Our Model
                </a>
              </button>
            </div>
            <div class="sidebar-category mt-1">
              <button id="results-category" class="btn format-clear btn-link btn-sm text-left pl-3" data-toggle="collapse" data-target="#results" aria-expanded="false" aria-controls="background">
                Results
              </button>

              <div id="results" class="collapse hide" aria-labelledby="results-category" data-parent="#sidebar-options">
                <ul class="list-unstyled">
                  <li>
                    <a href="#">
                      Coming Soon
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="place-credits-here"/>
          </div>
        </div>
      </div>
    );
  }
}

export default TemplateSidebar;

// <Link className="credits-link format-clear mt-auto align-self-start pb-0" to="/credits">
//   credits
// </Link>



// WEBPACK FOOTER //
// ./src/TemplateSidebar.js